<soft-page>
  <soft-page-header>
    <soft-date-navigator [date]="dateSelectionService.date()"
                         (dateChange)="dateSelectionService.setDate($event)"></soft-date-navigator>
  </soft-page-header>
  <soft-dashboard class="mt-2"></soft-dashboard>
</soft-page>
